exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PaginationVcDemo h4[data-v-2bc8a39f]{color:#066}.PaginationVcDemo .demoItem[data-v-2bc8a39f]{padding:10px 0;border-bottom:1px dotted #999}.PaginationVcDemo .demoItem .demoText[data-v-2bc8a39f]{margin:15px 10px 5px}", ""]);

// exports
